import { render, staticRenderFns } from "./BancaFarmaciViewComponent.vue?vue&type=template&id=0d16b20d"
import script from "./BancaFarmaciViewComponent.vue?vue&type=script&lang=js"
export * from "./BancaFarmaciViewComponent.vue?vue&type=script&lang=js"
import style0 from "./BancaFarmaciViewComponent.vue?vue&type=style&index=0&id=0d16b20d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports